import App from '@/store/modules/App'
import Auth from '@/store/modules/Auth'
import Notification from '@/store/modules/Notification'
import WebSocket from '@/store/modules/WebSocket'
import subscriptionPlugin from './plugins/subscriptionPlugin'

export default {
	modules: {
		App,
		Auth,
		Notification,
		WebSocket
	},
	plugins: [subscriptionPlugin]
}
